module.exports = __webpack_public_path__ + "img/module-messages.bff5dc95.svg";